import { render, staticRenderFns } from "./TapeDeliveryReceptionSheet.vue?vue&type=template&id=7f80aa33&scoped=true&"
import script from "./TapeDeliveryReceptionSheet.vue?vue&type=script&lang=ts&"
export * from "./TapeDeliveryReceptionSheet.vue?vue&type=script&lang=ts&"
import style0 from "./TapeDeliveryReceptionSheet.vue?vue&type=style&index=0&id=7f80aa33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f80aa33",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VCol,VContainer,VDivider,VIcon,VImg,VRow,VSpacer,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f80aa33')) {
      api.createRecord('7f80aa33', component.options)
    } else {
      api.reload('7f80aa33', component.options)
    }
    module.hot.accept("./TapeDeliveryReceptionSheet.vue?vue&type=template&id=7f80aa33&scoped=true&", function () {
      api.rerender('7f80aa33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/delivery-reception-tapes/TapeDeliveryReceptionSheet.vue"
export default component.exports